import { Component, Input, input } from "@angular/core";
import { NgClass } from "@angular/common";

interface HasLabelAndOptionalChangeMarkerAndTailored {
	label: string;
	tailored?: boolean;
	changeMarker?: {
		label?: string | null;
	};
}

@Component({
	selector: "stages-element-name",
	templateUrl: "./element-name.component.html",
	imports: [NgClass],
})
export class ElementNameComponent {
	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	self?: HasLabelAndOptionalChangeMarkerAndTailored;

	readonly headerLevel = input(1);

	@Input()
	showTitle = false;
}
